import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
import store from '@/store'

export const generateMKData = (recordItem, drugs) => ({
  hospitalID: store.state.user.userInfos.hospitalID,
  visitID: recordItem.visitID,
  schemaID: recordItem.schemaID,
  symptomCode: recordItem.symptomCode,
  symptomDesc: recordItem.symptomDesc,
  hospitalName: recordItem.hospitalName,
  doctorID: recordItem.doctorID,
  doctorName: recordItem.doctorName,
  deptID: recordItem.deptID,
  deptName: recordItem.deptName,
  patientID: recordItem.patientID,
  patientName: recordItem.patientName,
  patientSex: recordItem.patientSex,
  patientBirth: recordItem.patientBirth,
  patientAge: recordItem.patientAge,
  drugList: drugs.map((drug, index) => {
    // const batchNumber = item.batchNumber || item.drugItem.batchNumber || ''
    let batchNumber = ''
    if (drug.batchNumber) {
      batchNumber = drug.batchNumber
    } else if (drug.drugItem && drug.drugItem.batchNumber) {
      batchNumber = drug.drugItem.batchNumber
    }
    return {
      DrugUniqueCode:
        store.state.user.userInfos.hospitalID === '1886'
          ? `${drug.drugID}`
          : `${batchNumber}${drug.drugSpec}${drug.manufacturer}`,
      drugSpec: drug.drugSpec,
      manufacturer: drug.manufacturer,
      drugName: drug.drugName,
      useAuantity: drug.useAuantity,
      measureUnit: getKeyValueText('measure_unit', drug.measureUnit),
      frequence: drug.frequence,
      drugUsage: getKeyValueText('drug_usage_his', drug.drugUsage),
      amount: drug.amount,
      packageUnit: getKeyValueText('package_unit', drug.packageUnit) || drug.packageUnit,
      useDays: drug.useDays,
      warehouseID: drug.warehouseID,
      warehouseName: drug.warehouseName,
      attention: drug.attention
    }
  })
})
